import React, { Component } from 'react'
import MasterTemplatePageSF from '../MasterTemplatePageSF.js'

class MasterLoanAgrPoPageSF extends Component {
  render() {
    return (
      <MasterTemplatePageSF
        {...this.props}
        templateCode='loan_agreement_po'
        title='PO terms'
        activeTab='loanAgreement'
        navConfig={{ loanAgrPage: 'loanSpecific', subNavType: 'loanSpecific', subNavPage: 'po' }}
      />
    )
  }
}

export default MasterLoanAgrPoPageSF
